import React, { useEffect } from 'react';
import { Button } from 'antd';
import { getApiBaseUrl } from '../../utils';

export function LoginPage() {
  const startLogin = () => {
    const url = getApiBaseUrl() + '/login';
    window.location.href = url;
  };

  useEffect(() => {
    console.log('Redirecting to login...');
    startLogin();
  }, []);

  return (
    <div style={{ padding: '15rem 0', textAlign: 'center' }}>
      <h1>Giriş yapmalısınız!</h1>
      <h3>Uygulamayı kullanmak için giriş yapmalısınız.</h3>
      <Button type="default" style={{ marginTop: '3rem' }} onClick={startLogin}>
        Giriş yap
      </Button>
    </div>
  );
}
